import axios, { AxiosInstance } from "axios";

export class AxiosConfigurer {
  private readonly axiosInstance: AxiosInstance;

  private currentAuthToken: string | null = null;

  public constructor(baseUrl: string) {
    this.axiosInstance = axios.create({
      baseURL: baseUrl,
      withCredentials: true,
    });
    //Response interceptor could potentially be added for refreshing the token if needed
    this.axiosInstance.interceptors.request.use(
      (config) => {
        if (!config.headers.Authorization && this.currentAuthToken) {
          config.headers.Authorization = `Bearer ${this.currentAuthToken}`;
        }
        if (!config.headers["Content-Type"]) {
          config.headers["Content-Type"] = "application/json";
        }
        if (!config.headers.Accept) {
          config.headers.Accept = "application/json";
        }
        return config;
      },
      (error) => {
        return Promise.reject(error instanceof Error ? error : new Error(String(error)));
      },
    );
  }

  public setAuthToken(token: string | null): void {
    this.currentAuthToken = token;
  }

  public getAuthToken(): string | null {
    return this.currentAuthToken;
  }

  public getAxiosInstance() {
    return this.axiosInstance;
  }
}
